import client from './client';

export async function fetchAlerts(params) {
  const response = await client.get('/api/alerts', { params });
  return response.data;
}

export async function acknowledgeAlert(id) {
  const response = await client.put(`/api/alerts/${id}/ack`);
  return response.data;
}

export async function updateDisputeStatus(id, { dispute_status, notes }) {
  const response = await client.put(`/api/alerts/${id}/dispute`, { dispute_status, notes });
  return response.data;
}

export async function snoozeAlert(id, days = 7) {
  const response = await client.put(`/api/alerts/${id}/snooze`, { days });
  return response.data;
}

export async function batchAcknowledge(ids) {
  const response = await client.post('/api/alerts/batch/ack', { ids });
  return response.data;
}

export async function batchSnooze(ids, days = 7) {
  const response = await client.post('/api/alerts/batch/snooze', { ids, days });
  return response.data;
}

export async function batchDispute(ids, { dispute_status, notes }) {
  const response = await client.post('/api/alerts/batch/dispute', { ids, dispute_status, notes });
  return response.data;
}
